import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import propTypes from 'prop-types'


export default function Link(props) {
  const history = useHistory()

  const _onClick = (e, val) => {
    if (props.preventDefault)
      e.preventDefault()
      if (typeof(props.to) !== 'undefined') {
        history.push(props.to)
      } else {
        props.onClick()
      }

  }
  return (
    <a
      {...props}
      className={classNames([
        'transition-all',
        'inline-block cursor-pointer bg-white border-none outline-none focus:outline-none active:outline-none',
        'hover:text-primary-600',
        { 'pl-5 pr-5 pt-4 pb-4': ! props.noPadding },
        props.className,
      ])}
      onClick={() => _onClick()}
    >
      {props.children}
    </a>
  )
}

Link.propTypes = {
  className: propTypes.string,
  href: propTypes.string,
  onClick: propTypes.func,
  noPadding: propTypes.bool,
}

Link.preventDefault = {
  preventDefault: true,
  noPadding: false,
}
